module.exports = __webpack_public_path__ + "img/mockup-my-sam.318cba3.png";